/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-23 20:37:46
 * @LastEditTime: 2019-07-24 14:20:33
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 订单列表
export function getOrderListAll(params) {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/manage/order/findCmsOrder`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findAllCmsOrder'
      }, params))
    }
  })
}

//  确认
export function determineOrder(params) {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/manage/storage/findCmsStorageOrder`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'updateStatus'
      }, params))
    }
  })
}
//  拒绝
export function refuseOrder(params) {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/manage/storage/findCmsStorageOrder`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'delete'
      }, params))
    }
  })
}
// 取消发布
export function deleteStorageOrder(params) {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/manage/storage/findCmsStorageOrder`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'deleteStorageOrder'
      }, params))
    }
  })
}
// 货源取消发布
export function deleteStorageCmsOrder(params) {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/manage/order/findCmsOrder`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'delCmsOrder'
      }, params))
    }
  })
}
export function findAllCmsOrder(params) {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/cms/monitoring/findCmsOrder`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findAllCmsOrder'
      }, params))
    }
  })
}

const tankOrderUrl = `${LOGISTICE_GATEWAY}/manage/storage/findCmsStorageOrder`

const storageOrderUrl = `${LOGISTICE_GATEWAY}/manage/storage/findCmsStorageOrder`

// 罐区订单列表
export const getTankOrderListAll = (params) => {
  return logistice.post(tankOrderUrl, undefined, { serialize: false, params: { params: Object.assign(params, { 'methodName': 'findAllCmsStorageOrder' }, { 'orderType': '2' }) }})
}

// 罐区订单列表
export const getStorageOrderListAll = (params) => {
  return logistice.post(storageOrderUrl, undefined, { serialize: false, params: { params: Object.assign(params, { 'methodName': 'findAllCmsStorageOrder' }, { 'orderType': '1' }) }})
}

